window.addEventListener('load', function() {
  baguetteBox.run('.gallery');
});
